
import { MapLocation } from '@/types/location';

// Unity Gym Locations
export const unityGyms: MapLocation[] = [
  {
    id: 23001,
    name: "Unity Gym - Riyadh (Al Mohammadiyyah)",
    type: "Gym",
    devices: 2,
    coordinates: [24.735203528096477, 46.64794458771137],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
